import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useQuery } from "@tanstack/react-query";

export function getCustomAnalyticsReportFilterOptionsQueryKey(teamId: string) {
  return ["customAnalyticsReportFilterOptions", teamId] as const;
}

export function useCustomAnalyticsReportFilterOptionsQuery({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const team = useRequiredContext(TeamContext);
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  return useQuery({
    queryKey: getCustomAnalyticsReportFilterOptionsQueryKey(team._id),
    queryFn: async () => {
      return await rpcClient.getCustomAnalyticsReportFilterOptions({});
    },
    enabled,
  });
}
